<template>
  <div class="download">
    <div class="container">
      <div class="title">{{ $t('download.titulo') }}</div>
      <div v-if="loaded && getLanguage === 'es'" class="buttons-download">
        <div class="mr-40"><img src="../assets/buttons/get-app-android-es.svg" @click="goTo('android')" class="cursor-pointer" alt=""></div>
        <div><img src="../assets/buttons/get-app-ios-es.svg" @click="goTo('ios')" class="cursor-pointer" alt=""></div>
      </div>
      <div v-if="loaded && getLanguage !== 'es'" class="buttons-download">
        <div class="mr-40"><img src="../assets/buttons/get-app-android-en.svg" @click="goTo('android')" class="cursor-pointer" alt=""></div>
        <div><img src="../assets/buttons/get-app-ios-en.svg" @click="goTo('ios')" class="cursor-pointer" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import i18n from '../plugins/i18n.js'
export default {
  name: 'Download',
  data: () => ({
    loaded: false
  }),
  computed: {
    getLanguage () {
      return i18n.locale
    }
  },
  methods: {
    goTo (type) {
      let url = ''
      if (type === 'android') {
        url = this.$store.state.urlAndroid
      }
      if (type === 'ios') {
        url = this.$store.state.urlIos
      }
      window.open(url, '_blank')
    }
  },
  mounted () {
    this.loaded = true
  }
}
</script>

<style lang="scss" scoped>
.download {
  position: relative;
  width: 100%;
  background: url(../assets/bg-download.png) no-repeat center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    height: 100%;
    font-size: 36px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: wrap;
    text-align: left;
    padding-top: 140px;
    padding-bottom: 130px;

    > div {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .title {
      font-size: 36px;
      font-weight: 700;
      color: #444D67;
      margin-bottom: 40px;
    }

    .buttons-download {
      display: flex;
    }
  }

  @media(max-width: 1150px) {
    .container .title {
      font-size: 32px;
    }
  }

  @media(max-width: 920px) {
    .container {
      padding-top: 90px;
      padding-bottom: 80px;

      .title {
        font-size: 28px;
        text-align: center;
      }

      .buttons-download img {
        height: 55px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/download.vue